import React from 'react'
import { Formik, Form } from 'formik'
import { DfsRequirementsModal, AuthorizedCheckout, EmployeeInfoForm, RegistrationSection, enableDfsValidation, enableOptionGroupValidation, phoneNumberMask, blankInitialValues, employeeInfoValidation } from './shared'
import { conformToMask } from 'react-text-mask'
import { camelCase } from 'lodash'
import axios from 'axios'
import * as Yup from 'yup'

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

export class EmployeeForm extends React.Component {
  state = {
    dfsRequirementsModalOn: false,
    cart: {
      id: null,
      itemCount: 0,
      items: [],
      totalAmount: 0
    },
    event: null,
    co: null
  }

  componentDidMount = () => {
    enableOptionGroupValidation()
    enableDfsValidation()
    this.getCart()
  }

  setFocusedInput = (input) => {
    this.focusedInput = input
  }

  getCart = () => {
    axios.get(`${window.location.origin}${this.props.endpoint}`)
      .then(res => {
        const newInitialValues = { ...blankInitialValues, ...res.data.initialValues }
        newInitialValues.phone = conformToMask(newInitialValues.phone, phoneNumberMask).conformedValue

        for (const [key, value] of Object.entries(newInitialValues)) {
          if (value == null) newInitialValues[key] = ''
        }

        if (res.data.event.sections.length > 0) {
          newInitialValues.options = {}
          res.data.event.sections.map(item => {
            if (item.employee && item.sectionType == 'option_group') {
              newInitialValues.options[camelCase(item.name)] = ''
            }
          })
        }

        this.setState({ cart: res.data.cart })
        this.setState({ event: res.data.event })
        this.setState({ co: res.data.co })
        this.setState({ initialValues: newInitialValues })
        this.focusedInput.focus()
        console.log(res.data)
      })
      .catch(err => {
        console.log(err)
      })
  }

  postItem = (values, form) => {
    axios.post(`${window.location.origin}${this.props.endpoint}`, { data: values })
      .then(res => {
        this.setState({ cart: res.data })
        console.log(res.data)
      })
      .catch(err => {
        console.log(err)
      })
    form.setSubmitting(false)

    let newOptionValues = null
    if (values.options) {
      newOptionValues = { ...values.options }
      Object.keys(newOptionValues).forEach(key => {
        newOptionValues[key] = ''
      })
    }

    form.resetForm({
      firstName: '',
      lastName: '',
      company: values.company,
      accountManager: values.accountManager,
      email: '',
      phone: values.phone,
      requireDfs: false,
      acknowledgeDfs: false,
      dfsLicense: '',
      mobile: '',
      address: '',
      city: '',
      state: 'FL',
      zip: '',
      options: newOptionValues
    })
    this.focusedInput.focus()
  }

  deleteItem = (itemId) => {
    axios.delete(`${window.location.origin}${this.props.endpoint}/${itemId}`)
      .then(res => {
        this.setState({ cart: res.data })
        console.log(res.data)
      })
      .catch(err => {
        console.log(err)
      })
  }

  toggleDfsRequirementsModal = (e) => {
    e.preventDefault()
    this.setState({
      dfsRequirementsModalOn: !this.state.dfsRequirementsModalOn
    })
  }

  formValidation = () => {
    let optionsValidation = {}
    let dfsValidation = {}
    const terminal = 'employee'

    this.state.event.sections.map(section => {
      if (section.sectionType == 'option_group' && section[terminal]) {
        optionsValidation[camelCase(section.name)] = Yup.string().optionGroup(section, terminal)
      } else if (section.sectionType == 'dfs_form' && section[terminal]) {
        dfsValidation = Yup.string().dfs(section, terminal)
      }
    })

    let options = Yup.object().shape(optionsValidation)

    return Yup.object().shape({ ...employeeInfoValidation, options, ...dfsValidation })
  }

  render () {
    return (
      <React.Fragment>

        {this.state.initialValues &&
        <Formik
          initialValues={this.state.initialValues}
          validationSchema={this.formValidation}
          onSubmit={this.postItem}
          validateOnBlur={false}
          render={(form) => {
            return (
              <Form className='registration' noValidate>

                <EmployeeInfoForm form={form} setFocusedInput={this.setFocusedInput} />

                {this.state.event && this.state.event.sections.map(item => (
                  <RegistrationSection key={item.id} terminal='employee' section={item} form={form} toggleDfsRequirementsModal={this.toggleDfsRequirementsModal} />
                ))}

                <section>
                  <div className='field'>
                    <button type='submit' className='add-attendee' disabled={form.isSubmitting}>
                      <i /> Add to Cart
                    </button>
                  </div>
                </section>

              </Form>
            )
          }}
        />
        }

        <div className='side-bar'>

          <div className='cart'>
            <div className='cart-header'>
              <strong>Attendees: {this.state.cart.itemCount}</strong>
            </div>
            <ul className='cart-items'>
              {this.state.cart.items.map(item => (
                <CartItem key={item.id} item={item} onDelete={this.deleteItem} />
              ))}
            </ul>
            <div className='cart-total'>
              {'  '}
            </div>
          </div>

          {this.state.co && this.state.cart.items.length > 0 &&
          <React.Fragment>
            <div className='checkout'>
              <div className='checkout-body text-center'>
                <AuthorizedCheckout completeRegistrationLink={this.state.co.at} />
              </div>
            </div>
          </React.Fragment>
          }

        </div>

        <DfsRequirementsModal on={this.state.dfsRequirementsModalOn} toggle={this.toggleDfsRequirementsModal} />
      </React.Fragment>
    )
  }
}

class CartItem extends React.Component {
  handleDelete = () => {
    this.props.onDelete(this.props.item.id)
  }

  render () {
    return (
      <li className='cart-item'>
        <strong>{this.props.item.data.firstName} {this.props.item.data.lastName}</strong>
        <span className='delete-button' onClick={this.handleDelete}><i /></span>
        <ul className='item-details'>
          <li className='item-description'>{this.props.item.event.name}</li>
        </ul>
      </li>
    )
  }
}
